var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResultNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.964 9.23c-.015 0-.061 0-.084.055a.079.079 0 00.021.097l4.036 3.749c.035.033.09.033.126 0L9.1 9.382c.01-.01.044-.041.021-.097-.023-.055-.07-.055-.084-.055h-1.76L5.239.913C5.216.89 5.133.843 5 .843s-.216.047-.239.07L2.724 9.23H.964zM5 14a.978.978 0 01-.667-.26L.297 9.99A.906.906 0 01.07 8.97a.96.96 0 01.894-.584h1.07L3.917.704C4.017.29 4.463 0 5 0s.983.29 1.084.704l1.881 7.682h1.07a.96.96 0 01.895.585.907.907 0 01-.227 1.02l-4.036 3.748A.977.977 0 015 14z",
    fill: "#E64947",
    fillRule: "evenodd"
  })));
}

export default SvgResultNegative;